const maxUploadImageSide = 1024;
const uploadImageMimeType = 'image/jpeg';

export async function downsampleTopicImage(file: File): Promise<string> {
  const objectUrl = URL.createObjectURL(file);

  try {
    const img = new Image();
    const loaded = new Promise<void>((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = () => reject(new Error('Could not load image'));
    });
    img.src = objectUrl;
    await loaded;

    const width = img.naturalWidth || img.width;
    const height = img.naturalHeight || img.height;
    if (width <= 0 || height <= 0) {
      throw new Error('Invalid image dimensions');
    }

    const scale = Math.min(1, maxUploadImageSide / Math.max(width, height));
    const targetWidth = Math.max(1, Math.round(width * scale));
    const targetHeight = Math.max(1, Math.round(height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = targetWidth;
    canvas.height = targetHeight;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Canvas is unavailable');
    }
    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

    const dataUrl = canvas.toDataURL(uploadImageMimeType, 0.86);
    if (!dataUrl || dataUrl === 'data:,') {
      throw new Error('Could not encode image');
    }
    return dataUrl;
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
